const ROOTS = {
  auth: '/auth',
  dashboard: {
    root: '/dashboard',
    order: '/dashboard/order',
    bulk_order: '/dashboard/bulkorder',
    return: '/dashboard/return',
    inbound: '/dashboard/inbound',
    return_inbound: '/dashboard/return_inbound',
    outbound: '/dashboard/outbound',
    bulk_outbound: '/dashboard/bulk_outbound',
    export: '/dashboard/export',
    printing: '/dashboard/printing',
    inventory: '/dashboard/inventory',
    settings: '/dashboard/settings',
  },
};

export const PATHS = {
  home: '/',
  auth: {
    login: `${ROOTS.auth}/login`,
    forgotPassword: `${ROOTS.auth}/forgot-password`,
    resetPassword: `${ROOTS.auth}/reset-password`,
    chooseLocation: `${ROOTS.auth}/choose-location`,
  },
  dashboard: {
    root: `${ROOTS.dashboard.root}/root`,
    order: {
      root: `${ROOTS.dashboard.order}`,
      order: {
        root: `${ROOTS.dashboard.order}/order`,
        add: `${ROOTS.dashboard.order}/order/new`,
        edit: (id) => `${ROOTS.dashboard.order}/order/edit/${id}`,
      },
    },
    bulk_order: {
      root: `${ROOTS.dashboard.bulk_order}`,
      b2b: {
        root: `${ROOTS.dashboard.bulk_order}/b2b`,
        add: `${ROOTS.dashboard.bulk_order}/b2b/new`,
        edit: (id) => `${ROOTS.dashboard.bulk_order}/b2b/edit/${id}`,
      },
      withdrawal: {
        root: `${ROOTS.dashboard.bulk_order}/withdrawal`,
        add: `${ROOTS.dashboard.bulk_order}/withdrawal/new`,
        edit: (id) => `${ROOTS.dashboard.bulk_order}/withdrawal/edit/${id}`,
      },
      transfer: {
        root: `${ROOTS.dashboard.bulk_order}/transfer`,
        add: `${ROOTS.dashboard.bulk_order}/transfer/new`,
        edit: (id) => `${ROOTS.dashboard.bulk_order}/transfer/edit/${id}`,
      },
    },
    return: {
      root: `${ROOTS.dashboard.return}`,
      order: {
        root: `${ROOTS.dashboard.return}/order`,
        edit: (id) => `${ROOTS.dashboard.return}/order/edit/${id}`,
        add: `${ROOTS.dashboard.return}/order/new`,
      },
    },
    return_inbound: {
      root: `${ROOTS.dashboard.return_inbound}`,
      scan_tracking: `${ROOTS.dashboard.root}/scan_tracking`,
      detail: (returnId) => `${ROOTS.dashboard.return_inbound}/detail/${returnId}`,
    },
    inbound: {
      root: `${ROOTS.dashboard.inbound}`,
      inbound: {
        root: `${ROOTS.dashboard.inbound}/inbound`,
        edit: (id) => `${ROOTS.dashboard.inbound}/inbound/edit/${id}`,
        history: (id, purchaseOrderLine) =>
          `${ROOTS.dashboard.inbound}/inbound/edit/${id}/${purchaseOrderLine}`,
      },
      bulk_putaway: {
        root: `${ROOTS.dashboard.inbound}/bulk_putaway`,
        edit: (mode, target) => `${ROOTS.dashboard.inbound}/bulk_putaway/edit/${mode}/${target}`,
      },
      putaway: {
        root: `${ROOTS.dashboard.inbound}/putaway`,
        edit: (productCode) => `${ROOTS.dashboard.inbound}/putaway/edit/${productCode}`,
      },
    },
    outbound: {
      root: `${ROOTS.dashboard.outbound}`,
      outbound: {
        root: `${ROOTS.dashboard.outbound}/outbound`,
        edit: (id) => `${ROOTS.dashboard.outbound}/outbound/edit/${id}`,
      },
      shipping: {
        scan: {
          root: `${ROOTS.dashboard.outbound}/shipping/scan`,
        },
      },
      picking: {
        root: `${ROOTS.dashboard.outbound}/picking`,
        total_picking: (shipmentPickingId) =>
          `${ROOTS.dashboard.outbound}/picking/total/${shipmentPickingId}`,
        wave_picking: (shipmentPickingId) =>
          `${ROOTS.dashboard.outbound}/picking/wave/${shipmentPickingId}`,
      },
      packing: {
        root: `${ROOTS.dashboard.outbound}/packing`,
        multi: (locationId, scanNumber) =>
          `${ROOTS.dashboard.outbound}/packing/multi/${locationId}/${scanNumber}`,
      },
      single_packing: {
        root: `${ROOTS.dashboard.outbound}/single-packing`,
        picking: (pickingNumber) =>
          `${ROOTS.dashboard.outbound}/single-packing?pickingNumber=${pickingNumber}`,
        detail: (pickingNumber, shipmentId, scanNumber) =>
          `${ROOTS.dashboard.outbound}/single-packing?pickingNumber=${pickingNumber}&shipmentId=${shipmentId}&scanNumber=${scanNumber}`,
      },
      advance_tracking_number: {
        root: `${ROOTS.dashboard.outbound}/advance-tracking-number`,
      },
      sorting: {
        root: `${ROOTS.dashboard.outbound}/sorting`,
        scan: (shipmentPickingId) =>
          `${ROOTS.dashboard.outbound}/sorting/scan/${shipmentPickingId}`,
        detail: (shipmentPickingId) =>
          `${ROOTS.dashboard.outbound}/sorting/detail/${shipmentPickingId}`,
      },
    },
    bulk_outbound: {
      root: `${ROOTS.dashboard.bulk_outbound}`,
      bulk_outbound: {
        root: `${ROOTS.dashboard.bulk_outbound}/bulk-outbound`,
        edit: (id) => `${ROOTS.dashboard.bulk_outbound}/bulk-outbound/edit/${id}`,
      },
      bulk_picking: {
        root: `${ROOTS.dashboard.bulk_outbound}/picking`,
        total_picking: (shipmentPickingId) =>
          `${ROOTS.dashboard.bulk_outbound}/picking/total/${shipmentPickingId}`,
      },
      bulk_packing: {
        root: `${ROOTS.dashboard.bulk_outbound}/packing`,
        detail: (locationId, type, scanNumber) =>
          `${ROOTS.dashboard.bulk_outbound}/packing/${locationId}/${type}/${scanNumber}`,
      },
      bulk_shipping: {
        scan: {
          root: `${ROOTS.dashboard.bulk_outbound}/shipping/scan`,
        },
      },
    },
    export: {
      root: `${ROOTS.dashboard.export}`,
      carton: {
        root: `${ROOTS.dashboard.export}/carton`,
        edit: (id) => `${ROOTS.dashboard.export}/carton/${id}`,
      },
      manifest: {
        root: `${ROOTS.dashboard.export}/manifest`,
        edit: (id) => `${ROOTS.dashboard.export}/manifest/${id}`,
      },
      ready_to_manifest: {
        root: `${ROOTS.dashboard.export}/ready-to-manifest`,
      },
    },
    printing: {
      root: `${ROOTS.dashboard.printing}`,
      label: `${ROOTS.dashboard.printing}/label`,
      document: `${ROOTS.dashboard.printing}/document`,
    },
    inventory: {
      root: `${ROOTS.dashboard.inventory}`,
      products: {
        root: `${ROOTS.dashboard.inventory}/products`,
        add: `${ROOTS.dashboard.inventory}/products/new`,
        edit: (userId, id) => `${ROOTS.dashboard.inventory}/products/edit/${userId}/${id}`,
      },
      outerbox: {
        root: `${ROOTS.dashboard.inventory}/outerbox`,
        add: `${ROOTS.dashboard.inventory}/outerbox/new`,
        edit: (productOuterBoxId) =>
          `${ROOTS.dashboard.inventory}/outerbox/edit/${productOuterBoxId}`,
      },
      stock: {
        root: `${ROOTS.dashboard.inventory}/stock`,
        edit: (userId, id) => `${ROOTS.dashboard.inventory}/stock/edit/${userId}/${id}`,
      },
      adjustment_tasks: {
        root: `${ROOTS.dashboard.inventory}/adjustment-tasks`,
        edit: (adjustmentTaskId) =>
          `${ROOTS.dashboard.inventory}/adjustment-tasks/edit/${adjustmentTaskId}`,
      },
      adjustment_management: {
        root: `${ROOTS.dashboard.inventory}/adjustment-management`,
        add: `${ROOTS.dashboard.inventory}/adjustment-management/new`,
        edit: (adjustmentManagementId) =>
          `${ROOTS.dashboard.inventory}/adjustment-management/edit/${adjustmentManagementId}`,
      },
      transfer: {
        root: `${ROOTS.dashboard.inventory}/transfer`,
        edit: (productCode) => `${ROOTS.dashboard.inventory}/transfer/edit/${productCode}`,
      },
      bulk_transfer: {
        root: `${ROOTS.dashboard.inventory}/bulk_transfer`,
        edit: (mode, target) => `${ROOTS.dashboard.inventory}/bulk_transfer/edit/${mode}/${target}`,
      },
      purchase_order: {
        root: `${ROOTS.dashboard.inventory}/purchase-order`,
        add: `${ROOTS.dashboard.inventory}/purchase-order/new`,
        edit: (id) => `${ROOTS.dashboard.inventory}/purchase-order/edit/${id}`,
      },
    },
    settings: {
      root: `${ROOTS.dashboard.settings}`,
      users: {
        root: `${ROOTS.dashboard.settings}/users`,
        list: (tab) => `${ROOTS.dashboard.settings}/users${tab ? `?tab=${tab}` : ''}`,
        add: `${ROOTS.dashboard.settings}/users/new`,
        edit: (id, tab) =>
          `${ROOTS.dashboard.settings}/users/edit/${id}${tab ? `?tab=${tab}` : ''}`,
        location: (id) => `${ROOTS.dashboard.settings}/users/location/${id}`,
        customer: (id) => `${ROOTS.dashboard.settings}/users/customer/${id}`,
      },
      locations: {
        root: `${ROOTS.dashboard.settings}/locations`,
        add: `${ROOTS.dashboard.settings}/locations/new`,
        edit: (id) => `${ROOTS.dashboard.settings}/locations/edit/${id}`,
      },
      location_management: {
        root: `${ROOTS.dashboard.settings}/location-management`,
        add: (type) => `${ROOTS.dashboard.settings}/location-management/${type}/new`,
        edit: (type, locationId, number) =>
          `${ROOTS.dashboard.settings}/location-management/${type}/edit/${locationId}/${number}`,
      },
      packing_materials: {
        root: `${ROOTS.dashboard.settings}/packing-materials`,
        add: `${ROOTS.dashboard.settings}/packing-materials/new`,
        edit: (id) => `${ROOTS.dashboard.settings}/packing-materials/edit/${id}`,
      },
      sorter_management: {
        root: `${ROOTS.dashboard.settings}/sorter-management`,
        add: `${ROOTS.dashboard.settings}/sorter-management/new`,
        edit: (locationId, id) =>
          `${ROOTS.dashboard.settings}/sorter-management/edit/${locationId}/${id}`,
      },
      machine: {
        root: `${ROOTS.dashboard.settings}/machine`,
        add: `${ROOTS.dashboard.settings}/machine/new`,
        edit: (id) => `${ROOTS.dashboard.settings}/machine/edit/${id}`,
      },
      manifest_setting: {
        root: `${ROOTS.dashboard.settings}/manifest-setting`,
        add: `${ROOTS.dashboard.settings}/manifest-setting/new`,
        edit: (id) => `${ROOTS.dashboard.settings}/manifest-setting/edit/${id}`,
      },
      shipper_setting: {
        root: `${ROOTS.dashboard.settings}/shipper-setting`,
        add: `${ROOTS.dashboard.settings}/shipper-setting/new`,
        edit: (id) => `${ROOTS.dashboard.settings}/shipper-setting/edit/${id}`,
      },
      channels: {
        root: `${ROOTS.dashboard.settings}/channels`,
        add: `${ROOTS.dashboard.settings}/channels/new`,
        edit: (id) => `${ROOTS.dashboard.settings}/channels/edit/${id}`,
      },
      mapping_code: `${ROOTS.dashboard.settings}/mapping-code`,
      invoice_masking: `${ROOTS.dashboard.settings}/invoice-masking`,
      webhooks: `${ROOTS.dashboard.settings}/webhooks`,
      supplier: {
        root: `${ROOTS.dashboard.settings}/supplier`,
        add: `${ROOTS.dashboard.settings}/supplier/new`,
        edit: (id) => `${ROOTS.dashboard.settings}/supplier/edit/${id}`,
      },
      app_release: `${ROOTS.dashboard.settings}/app-release`,
      feature_setting: {
        root: `${ROOTS.dashboard.settings}/feature-setting`,
        add: `${ROOTS.dashboard.settings}/feature-setting/new`,
        edit: (id) => `${ROOTS.dashboard.settings}/feature-setting/edit/${id}`,
      },
    },
  },
};
